<mat-drawer-container class="studioLayout">
  <mat-drawer-content class="studioContent">
    <div class="content">
      <div class="content-header">
        <div class="left">
          <input
            type="range"
            [formControl]="scaleControl"
            min="{{ minScaleValue | async }}"
            max="{{ maxScaleValue | async }}"
            step=".001"
          />
          <lib-checkbox [formControl]="showSpine"
            >Pokaż bezpieczne strefy druku
          </lib-checkbox>
          <lib-button icon-only (click)="undo()">
            <mat-icon>undo</mat-icon>
          </lib-button>
          <lib-button
            icon-only
            (click)="redo()"
            [disabled]="!(isRedoAvailable$ | async)"
          >
            <mat-icon>redo</mat-icon>
          </lib-button>
        </div>
        <lib-button icon-only (click)="showDump()">
          <mat-icon>debug</mat-icon>
        </lib-button>
        <div>
          <lib-button (click)="saveAndExit()" [isLoading$]="saveInProgress$"
            >Zapisz i zamknij
          </lib-button>
        </div>
      </div>
      @if (saveError$ | async) {
        <div class="save-error" role="alert">
          <span>Nie udało się zapisać projektu. Spróbuj ponownie.</span>
          <lib-button (click)="retrySave()" [isLoading$]="saveInProgress$"
            >Ponów zapis</lib-button
          >
        </div>
      }
      @if (historyError$ | async) {
        <div class="history-error" role="status">
          Nie udało się zachować historii cofania zmian.
        </div>
      }
      <div #canvaContainer class="canvaContainer">
        <lib-tablo-canva
          [structureAlreadySet]="!(pushChangesDownstream | async)"
          [currentPage]="currentPage$ | async"
          [publicSessionOrganizationId]="publicSessionOrganizationId"
          [publicSessionOrganizationGroupId]="publicSessionOrganizationGroupId"
          [publicSessionSignupCampaignId]="publicSessionSignupCampaignId"
          [template]="currentTemplate$ | async"
          [structure]="projectStructureToPassDown$ | async"
          [photoSourceGroups]="sourceGroups$ | async"
          [context]="context"
          [contextId]="contextId"
          (openEditMode)="openEditMode($event)"
          (minScaleSet)="minScaleSet($event)"
          [disabled]="isSpaceDown$ | async"
          [leadingChildId]="leadingChildId$ | async"
          (closeEditMode)="sidebarBack()"
          [projectId]="projectId"
          [showSpine]="showSpine.value"
          [ngClass]="{
            disabled: isSpaceDown$ | async,
          }"
          [updatedScale]="scaleForEditor | async"
          [translated]="{
            x: x$ | async,
            y: y$ | async,
          }"
          [isTemplate]="isTemplateEditor"
          (structureUpdated)="structureUpdatedFromCanva($event)"
          (isCanvasReady)="canvasLoaded()"
          (scrollZoomUpdated)="scrollZoomUpdated($event)"
          (backgroundTransformUpdated)="backgroundTransformUpdated($event)"
          (enableMoveByDragAndDrop)="enableMoveFromCanvas($event)"
          [hasSpine]="showSpine.value"
          [askForFaceMatch]="askForFaceMatch | async"
          (photosAssigned)="photosAssigned($event)"
          (removeItem)="removeItem($event)"
          [photographerLogo]="
            $safeNavigationMigration(
              (photographerLogoFile$ | async)?.horizontalLogo
            )
          "
          (overflowError)="overflowError($event)"
          (editCrop)="editCrop($event)"
          [mightHaveSpine]="tabloType !== tabloTypes.SinglePage"
          (editCustomIndex)="editSingleChild($event.group, $event.index)"
          (requestSourcePhotoPicker)="handleSourcePhotoPicker($event)"
          [hideControls]="hideControls | async"
        ></lib-tablo-canva>
      </div>
      @if (tabloType === tabloTypes.TwoPage) {
        <div class="footer">
          <div
            class="page"
            [ngClass]="{
              active: (currentPage$ | async) === 0,
            }"
            (click)="currentPage$.next(0)"
          >
            Okładka
          </div>
          <div
            class="page"
            [ngClass]="{
              active: (currentPage$ | async) === 1,
            }"
            (click)="currentPage$.next(1)"
          >
            Wnętrze
          </div>
        </div>
      }
      @if (isPreloading$ | async) {
        <mat-progress-spinner
          mode="indeterminate"
          [diameter]="200"
        ></mat-progress-spinner>
      }
    </div>
  </mat-drawer-content>

  <!--<div class="structure">-->
  <!--  <pre>-->
  <!--    {{ fullProject$ | async | json }}-->
  <!--  </pre>-->
  <!--  <pre>-->
  <!--    {{ projectStructure$ | async | json }}-->
  <!--  </pre>-->
  <!--</div>-->
  <mat-drawer class="sidebarDrawer" position="end" mode="side" [opened]="true">
    @if (sidebarState$ | async; as sidebarState) {
      <lib-tablo-sidebar-shell
        [title]="getSidebarTitle(sidebarState.current.panel)"
        [showBack]="sidebarState.canGoBack"
        [panel]="sidebarState.current.panel"
        (back)="sidebarBack()"
      >
        @switch (sidebarState.current.panel) {
          @case ('main') {
            <ng-container *ngTemplateOutlet="mainMenu"></ng-container>
          }
          @case ('layers') {
            <lib-tablo-layers-editor
              [membersMenu$]="membersMenu$"
              [namesMenu$]="namesMenu$"
              [leadingChild$]="leadingChild$"
              [leadingChildPhotoOnly$]="leadingChildPhotoOnly$"
              [leadingChildNameOnly$]="leadingChildNameOnly$"
              [organizationLogo$]="organizationLogo$"
              [photographerLogo$]="photographerLogo$"
              [isSinglePageTablo]="isSinglePageTablo"
              (addMembersGroup)="addMembersGroup($event)"
              (addLeadingChild)="
                addLeadingChild(
                  $safeNavigationMigration($event?.isNameOnly),
                  $safeNavigationMigration($event?.isPhotoOnly)
                )
              "
              (addText)="addText($event)"
              (addLogo)="addLogo()"
              (addPhotographerLogo)="addPhotographerLogo()"
              (addStaticText)="addStaticText()"
              (addGraphic)="addGraphic($event)"
              (addSchoolPhoto)="addSchoolPhoto()"
              (addChildStaticPhoto)="addChildStaticPhoto()"
              (addQr)="addQr()"
            ></lib-tablo-layers-editor>
          }
          @case ('group-edit') {
            <ng-container *ngTemplateOutlet="groupEditForm"></ng-container>
          }
          @case ('text-edit') {
            <ng-container *ngTemplateOutlet="editTextForm"></ng-container>
          }
          @case ('static-text-edit') {
            <ng-container *ngTemplateOutlet="editStaticTextForm"></ng-container>
          }
          @case ('photo-edit') {
            <ng-container
              *ngTemplateOutlet="editPhotoConfigForm"
            ></ng-container>
          }
          @case ('graphic-edit') {
            <ng-container
              *ngTemplateOutlet="editGraphicConfigForm"
            ></ng-container>
          }
          @case ('face-match') {
            <ng-container
              *ngTemplateOutlet="singlePhotoFaceMatch"
            ></ng-container>
          }
          @case ('single-child-edit') {
            <ng-container
              *ngTemplateOutlet="singleChildEditForm"
            ></ng-container>
          }
        }
      </lib-tablo-sidebar-shell>
    }
  </mat-drawer>
  <ng-template #mainMenu>
    <div class="mainMenu">
      @if (isTemplateEditor) {
        <lib-single-file-uploader
          [reverseLabel]="true"
          [context]="uploadContextForAssets"
          [contextId]="projectId"
          [formControl]="backgroundImage"
          (fileChanged)="backgroundImageFileChanged($event)"
          #backgroundImageUploader
          >Tło
          <label>Tło</label>
        </lib-single-file-uploader>
      }
      <lib-button (click)="showLayersEditor()">Dodaj element</lib-button>
      <div cdkDropList class="layers" (cdkDropListDropped)="dropLayer($event)">
        @for (layer of layers$ | async; track layer) {
          <div
            class="layer"
            cdkDrag
            [cdkDragData]="layer"
            (pointerenter)="pointerOverLayer(layer)"
            (pointerleave)="pointerLeftLayer(layer)"
          >
            <span>
              @switch (layer.type) {
                @case ('group') {
                  @if (layer.isLeadingChild) {
                    Dziecko wiodące
                    @if (layer.config.config.isPhotoOnly) {
                      - Zdjęcie
                    }
                    @if (layer.config.config.isNameOnly) {
                      - Podpis
                    }
                  }
                  @if (!layer.isLeadingChild) {
                    @switch (layer.config.list.type) {
                      @case ('student') {
                        Uczniowie
                      }
                      @case ('teacher') {
                        Kadra
                      }
                    }
                  }
                }
                @case ('text') {
                  @switch (layer.config.source) {
                    @case ('PublicSessionOrganizationGroup') {
                      Nazwa grupy
                    }
                    @case ('PublicSessionOrganization') {
                      Nazwa placówki
                    }
                  }
                }
                @case ('statictext') {
                  {{ layer | staticTextLabel }}
                }
                @case ('qr') {
                  Kod qr
                }
                @case ('logo') {
                  Logo placówki
                }
                @case ('graphic') {
                  Grafika
                }
                @case ('staticChildPhoto') {
                  Dodatkowe zdjęcie
                }
                @case ('photoOfSchool') {
                  Zdjęcie placówki
                }
                @case ('photographerLogo') {
                  Moje logo
                }
              }
            </span>
            @if (layer.type !== 'qr') {
              <lib-button (click)="openEditMode(layer)" icon-only>
                <mat-icon>edit</mat-icon>
              </lib-button>
            }
            <lib-button confirm (clicked)="removeItem(layer.id)" icon-only>
              <mat-icon>delete</mat-icon>
            </lib-button>
            <lib-button
              icon-only
              (click)="toggleElementVisibility(layer.id, !layer.config.hidden)"
            >
              @if (!layer.config.hidden) {
                <mat-icon>visibility_on</mat-icon>
              }
              @if (layer.config.hidden) {
                <mat-icon>visibility_off</mat-icon>
              }
            </lib-button>
            <lib-button
              icon-only
              (click)="toggleElementLock(layer.id, !layer.config.locked)"
            >
              @if (!layer.config.locked) {
                <mat-icon> lock_open</mat-icon>
              }
              @if (layer.config.locked) {
                <mat-icon> lock</mat-icon>
              }
            </lib-button>
            @if (layer.type === 'graphic') {
              <lib-button icon-only (click)="duplicateGraphic(layer.id)">
                <mat-icon>content_copy</mat-icon>
              </lib-button>
            }
          </div>
        }
      </div>
      <div class="spacer"></div>
      <div class="validation">
        @if ((validationStatus$ | async)?.isValid) {
          <mat-icon>check</mat-icon>
          Projekt jest poprawny
        } @else {
          <mat-icon class="error">error</mat-icon>
          Projekt zawiera błędy.
          <lib-button (click)="showErrors()">Pokaż</lib-button>
        }
      </div>
    </div>
  </ng-template>
  <ng-template #editTextForm>
    <lib-tablo-text-editor
      [currentConfig]="currentTextConfig"
      [publicSessionOrganizationId]="publicSessionOrganizationId"
      (updated)="textUpdated($event)"
    ></lib-tablo-text-editor>
  </ng-template>
  <ng-template #editStaticTextForm>
    <lib-tablo-static-text-editor
      [currentConfig]="currentTextConfig"
      (updated)="staticTextUpdated($event)"
    ></lib-tablo-static-text-editor>
  </ng-template>
  <ng-template #editPhotoConfigForm>
    <lib-static-photo-config-editor
      [currentConfig]="currentPhotoConfig"
      [uploadContextForAssets]="uploadContextForAssets"
      [projectId]="projectId"
      [photoType]="currentStaticPhotoType"
      (updated)="staticPhotoUpdated($event)"
      [context]="context"
      [contextId]="contextId"
      [publicSessionOrganizationId]="publicSessionOrganizationId"
      [organizationSettings]="currentOrganizationDetails$ | async"
    ></lib-static-photo-config-editor>
  </ng-template>
  <ng-template #editGraphicConfigForm>
    <lib-static-graphic-config
      [currentConfig]="currentGraphicConfig"
      (updated)="staticGraphicUpdated($event)"
    ></lib-static-graphic-config>
  </ng-template>
  <ng-template #groupEditForm>
    <div [formGroup]="config" class="menu groupMenu">
      @if ((subEditorType$ | async) === 'student' && !isTemplateEditor) {
        <mat-form-field libZalamoField>
          <mat-label>Źródło zdjęć</mat-label>
          <mat-select [formControl]="photoSourceControl" [multiple]="true">
            @for (option of sourceGroups$ | async; track option) {
              <mat-option [value]="option.photoGroupId"
                >{{ option.label | langPicker | async }} ({{
                  option.imagesCount
                }}
                zdjęć)
              </mat-option>
            }
          </mat-select>
          <lib-zalamo-field-decoration></lib-zalamo-field-decoration
        ></mat-form-field>
      }
      @if ((subEditorType$ | async) === 'student' && leadingChildId$ | async) {
        <lib-checkbox formControlName="hideLeadingChild"
          >Ukryj główne dziecko
        </lib-checkbox>
      }
      @if ((subEditorType$ | async) === 'leadingChild') {
        <mat-form-field libZalamoField>
          <mat-label>Uczeń</mat-label>
          <mat-select formControlName="leadingChildId">
            @for (option of attendance$ | async; track option) {
              <mat-option [value]="option.value">{{ option.name }} </mat-option>
            }
          </mat-select>
          <lib-zalamo-field-decoration></lib-zalamo-field-decoration
        ></mat-form-field>
      }
      @if ((subEditorType$ | async) === 'teacher') {
        <lib-button (click)="addTeacher()">Kadra w tej grupie</lib-button>
        <lib-checkbox formControlName="showDirectors"
          >Pokaż dyrekcję
        </lib-checkbox>
        @if (config.value.showDirectors) {
          <lib-checkbox formControlName="directorsGoFirst"
            >Dyrekcja jako pierwsza
          </lib-checkbox>
        }
        <lib-button (click)="editAllTeachers()">Kadra w placówce</lib-button>
      }
      @if ((subEditorType$ | async) !== 'leadingChild') {
        <mat-form-field libZalamoField>
          <mat-label>lista obecności</mat-label>
          <mat-select [multiple]="true" formControlName="attendants">
            @for (
              option of attendance$ | async;
              track trackAttendance($index, option)
            ) {
              <mat-option [value]="option.value">{{ option.name }} </mat-option>
            }
          </mat-select>
          <lib-zalamo-field-decoration></lib-zalamo-field-decoration
        ></mat-form-field>
      }
      @if ((subEditorType$ | async) !== 'leadingChild') {
        <app-change-number formControlName="itemsPerRow"
          >Osób w wierszu
        </app-change-number>
        <div class="options">
          <lib-button
            [ngClass]="{
              picked: config.value.align === 'left',
            }"
            icon-only
            (click)="
              config.patchValue({
                align: 'left',
              })
            "
          >
            <mat-icon>format_align_left</mat-icon>
          </lib-button>
          <lib-button
            [ngClass]="{
              picked: config.value.align === 'center',
            }"
            icon-only
            (click)="
              config.patchValue({
                align: 'center',
              })
            "
          >
            <mat-icon>format_align_center</mat-icon>
          </lib-button>
          <lib-button
            icon-only
            [ngClass]="{
              picked: config.value.align === 'right',
            }"
            (click)="
              config.patchValue({
                align: 'right',
              })
            "
          >
            <mat-icon>format_align_right</mat-icon>
          </lib-button>
        </div>
        @if (config.value.itemsPerRow > 1) {
          <lib-checkbox formControlName="addSpine">Dodaj grzbiet</lib-checkbox>
        }
        @if (config.value.addSpine) {
          <app-change-number formControlName="spineSize" [minNumber]="0"
            >Rozmiar grzbietu
          </app-change-number>
        }
        <app-change-number formControlName="childVerticalMargin" [minNumber]="0"
          >Odstęp między wierszami
        </app-change-number>
        <app-change-number
          formControlName="childHorizontalMargin"
          [minNumber]="0"
          >Odstęp między kolumnami
        </app-change-number>
      }
      <app-change-number
        formControlName="sideMargin"
        [minNumber]="0"
        [step]="10"
        >Boczne marginesy
      </app-change-number>
      @if ((subEditorType$ | async) !== 'leadingChild') {
        <h3>Pojedyńcza osoba</h3>
        <mat-form-field libZalamoField>
          <mat-label>Różnicuj wygląd osób</mat-label>
          <mat-select formControlName="childConfigDifferenceRule">
            <mat-option value="none">Nie różnicuj</mat-option>
            <mat-option value="oddEven">Parzyste/nieparzyste</mat-option>
            <mat-option value="oddEvenRow"
              >Parzyste/nieparzyste rzędy</mat-option
            >
          </mat-select>
          <lib-zalamo-field-decoration></lib-zalamo-field-decoration
        ></mat-form-field>
      }
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Ogólne</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="expansionPanelContent">
            <app-change-number
              formControlName="childTilt"
              [minNumber]="0"
              [maxLabelWidth]="true"
              >Losowe obrócenie osoby
            </app-change-number>
            <app-change-number
              formControlName="childPositionDistortion"
              [minNumber]="0"
              [maxLabelWidth]="true"
              >Losowe przesunięcie osoby
            </app-change-number>

            @if (
              config.value.childConfigDifferenceRule === 'oddEven' ||
              config.value.childConfigDifferenceRule === 'oddEvenRow'
            ) {
              <h3>Nieparzyste:</h3>
              <ng-container
                *ngTemplateOutlet="childConfig; context: { mode: 'Odd' }"
              ></ng-container>
              <h3>Parzyste:</h3>
              <ng-container
                *ngTemplateOutlet="childConfig; context: { mode: 'Even' }"
              ></ng-container>
            }
            @if (config.value.childConfigDifferenceRule === 'none') {
              <ng-container
                *ngTemplateOutlet="childConfig; context: { mode: '' }"
              ></ng-container>
            }
          </div>
        </mat-expansion-panel>
        @if (!config.value.isNameOnly) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>Zdjęcie</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansionPanelContent">
              @if (
                !config.value.photoAsBackground && !config.value.photoAsSquare
              ) {
                <lib-checkbox formControlName="photoAsCircle"
                  >Zdjęcie jako okrąg
                </lib-checkbox>
              }
              @if (
                !config.value.photoAsBackground && !config.value.photoAsCircle
              ) {
                <lib-checkbox formControlName="photoAsSquare"
                  >Zdjęcie jako kwadrat
                </lib-checkbox>
              }
              @if (!config.value.photoAsCircle && !config.value.photoAsSquare) {
                <lib-checkbox formControlName="photoAsBackground"
                  >Zdjęcie jako tło
                </lib-checkbox>
              }
              <lib-checkbox formControlName="maximizePhoto"
                >Maksymalizuj zdjecie
              </lib-checkbox>
              @if (!config.value.photoAsCircle) {
                <app-change-number
                  formControlName="photoRadius"
                  [maxNumber]="5000"
                  [minNumber]="0"
                  >Zaokrąglone rogi zdjęcia
                </app-change-number>
              }
              @if (
                config.value.childConfigDifferenceRule === 'oddEven' ||
                config.value.childConfigDifferenceRule === 'oddEvenRow'
              ) {
                <h3>Nieparzyste:</h3>
                <ng-container
                  *ngTemplateOutlet="childPhotoConfig; context: { mode: 'Odd' }"
                ></ng-container>
                <h3>Parzyste:</h3>
                <ng-container
                  *ngTemplateOutlet="
                    childPhotoConfig;
                    context: { mode: 'Even' }
                  "
                ></ng-container>
              }
              @if (config.value.childConfigDifferenceRule === 'none') {
                <ng-container
                  *ngTemplateOutlet="childPhotoConfig; context: { mode: '' }"
                ></ng-container>
              }
            </div>
          </mat-expansion-panel>
        }

        @if (!config.value.isPhotoOnly) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>Podpis</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansionPanelContent">
              <mat-form-field libZalamoField>
                <mat-label> Wyświetlaine imienia i nazwiska</mat-label>
                <mat-select formControlName="nameHandling">
                  <mat-option value="split">
                    Imię i nazwisko w osobnych wierszach
                  </mat-option>
                  <mat-option value="join">
                    Imię i nazwisko w jednym wierszu
                  </mat-option>
                  <mat-option value="firstNameOnly"> Tylko imię</mat-option>
                  @if (!config.value.isNameOnly) {
                    <mat-option value="incognito">Brak podpisu </mat-option>
                  }
                </mat-select>
                <lib-zalamo-field-decoration></lib-zalamo-field-decoration
              ></mat-form-field>
              <app-change-number
                formControlName="childPhotoNameToPhotoGap"
                [minNumber]="-1200"
                [maxNumber]="500"
                [step]="5"
                [maxLabelWidth]="true"
              >
                Odstęp między zdjęciem a podpisem
              </app-change-number>
              <app-change-number
                formControlName="childFirstNameMaxFontSize"
                [minNumber]="10"
                [maxNumber]="1000"
                [maxLabelWidth]="true"
                >Maksymalny rozmiar czcionki pierwszego pola
              </app-change-number>
              <app-change-number
                formControlName="childFirstNameHeight"
                [minNumber]="10"
                [maxNumber]="500"
                [maxLabelWidth]="true"
                >Wysokość pierwszego pola
              </app-change-number>
              @if (
                config.value.nameHandling === 'split' ||
                (isEditingTeacherGroup$ | async)
              ) {
                <app-change-number
                  formControlName="childLastNameHeight"
                  [minNumber]="10"
                  [maxNumber]="500"
                  [maxLabelWidth]="true"
                  >Wysokośc drugiego pola
                </app-change-number>
              }
              @if (
                config.value.nameHandling === 'split' ||
                (isEditingTeacherGroup$ | async)
              ) {
                <app-change-number
                  formControlName="childLastNameMaxFontSize"
                  [minNumber]="10"
                  [maxLabelWidth]="true"
                  >Maksymalny rozmiar czcionki drugiego pola
                </app-change-number>
              }
              @if (
                config.value.nameHandling === 'split' ||
                (isEditingTeacherGroup$ | async)
              ) {
                <app-change-number
                  formControlName="childNamesGap"
                  [minNumber]="0"
                  [maxLabelWidth]="true"
                  [maxNumber]="1000"
                  >Odstęp między polami
                </app-change-number>
              }
              <app-change-number
                formControlName="childNameTilt"
                [minNumber]="0"
                [maxLabelWidth]="true"
                >Losowy obrót
              </app-change-number>
              @if (
                config.value.childConfigDifferenceRule === 'oddEven' ||
                config.value.childConfigDifferenceRule === 'oddEvenRow'
              ) {
                <h3>Nieparzyste:</h3>
                <ng-container
                  *ngTemplateOutlet="childNameConfig; context: { mode: 'Odd' }"
                ></ng-container>
                <h3>Parzyste:</h3>
                <ng-container
                  *ngTemplateOutlet="childNameConfig; context: { mode: 'Even' }"
                ></ng-container>
              }
              @if (config.value.childConfigDifferenceRule === 'none') {
                <ng-container
                  *ngTemplateOutlet="childNameConfig; context: { mode: '' }"
                ></ng-container>
              }
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>

      <ng-template #childPhotoConfig let-mode="mode">
        <app-change-number
          formControlName="childPhotoFrameWidth{{ mode }}"
          [maxLabelWidth]="true"
          [minNumber]="0"
        >
          Grubość ramki
        </app-change-number>
        @if (config.value['childPhotoFrameWidth' + mode]) {
          <div class="colorPicker">
            Kolor ramki:
            <input
              #me
              (colorPickerChange)="
                config.controls['childPhotoFrameColor' + mode].patchValue(
                  $event
                )
              "
              [cpUseRootViewContainer]="true"
              [(colorPicker)]="config.value['childPhotoFrameColor' + mode]"
              [style.background]="
                me.value
                  ? me.value
                  : config.value['childPhotoFrameColor' + mode]
              "
            />
          </div>
        }
        <lib-box-shadow-editor formControlName="childPhotoShadow{{ mode }}">
          Cieniowanie zdjęcia
        </lib-box-shadow-editor>

        <lib-single-file-uploader
          [reverseLabel]="true"
          [context]="uploadContextForAssets"
          [contextId]="projectId"
          [maxLabelWidth]="true"
          [size]="50"
          formControlName="childPhotoOverlayFileName{{ mode }}"
        >
          <label>Nakładka nad zdjęciem</label>
        </lib-single-file-uploader>

        @if (config.value['childPhotoOverlayFileName' + mode]) {
          <app-change-number
            formControlName="childPhotoOverlayScale{{ mode }}"
            [minNumber]="0"
            [maxLabelWidth]="true"
            [step]="0.01"
            >Rozmiar nakładki
          </app-change-number>
          <lib-checkbox
            formControlName="childPhotoOverlayHasColorOverlay{{ mode }}"
          >
            Koloruj nakładkę
          </lib-checkbox>
          @if (config.value['childPhotoOverlayHasColorOverlay' + mode]) {
            <div class="colorPicker">
              Kolor nakładki:
              <input
                #colorOverlayInput
                (colorPickerChange)="
                  config.controls[
                    'childPhotoOverlayColorOverlay' + mode
                  ].patchValue($event)
                "
                [(colorPicker)]="
                  config.value['childPhotoOverlayColorOverlay' + mode]
                "
                [style.background]="
                  colorOverlayInput.value
                    ? colorOverlayInput.value
                    : config.value['childPhotoOverlayColorOverlay' + mode]
                "
                cpPosition="auto"
                [cpUseRootViewContainer]="true"
              />
            </div>
          }
        }
        <app-change-number
          formControlName="photoSideMargins{{ mode }}"
          [minNumber]="0"
          [maxLabelWidth]="true"
          >Marginesy boczne zdjęcia
        </app-change-number>
      </ng-template>
      <ng-template #childNameConfig let-mode="mode">
        <lib-font-inline-picker formControlName="font{{ mode }}"
          >Czcionka
        </lib-font-inline-picker>
        <div class="range">
          <label>Odstęp między literami</label>
          <mat-slider min="-1" max="2" step=".01" discrete #spacing
            ><input
              matSliderThumb
              formControlName="fontLatterSpacing{{ mode }}"
          /></mat-slider>
          <lib-button icon-only (click)="spacing.value = 0">
            <mat-icon>refresh</mat-icon>
          </lib-button>
        </div>
        <lib-checkbox formControlName="uppercase{{ mode }}"
          >WIELKIE LITERY
        </lib-checkbox>
        <app-change-number
          formControlName="childNameFrameWidth{{ mode }}"
          [minNumber]="0"
          [maxLabelWidth]="true"
        >
          Grubość ramki
        </app-change-number>
        @if (config.value['childNameFrameWidth' + mode]) {
          <div class="colorPicker">
            Kolor ramki wokól imienia i nazwiska:
            <input
              #me
              (colorPickerChange)="
                config.controls['childNameNameFrameColor' + mode].patchValue(
                  $event
                )
              "
              [cpUseRootViewContainer]="true"
              [(colorPicker)]="config.value['childNameNameFrameColor' + mode]"
              [style.background]="
                me.value
                  ? me.value
                  : config.value['childNameNameFrameColor' + mode]
              "
            />
          </div>
        }
        @if (config.value['childNameFrameWidth' + mode]) {
          <app-change-number
            formControlName="childNameFrameRadius{{ mode }}"
            [minNumber]="0"
            [maxLabelWidth]="true"
            >Zaokrąglone rogi wokół imienia i nazwiska
          </app-change-number>
        }
        <app-change-number
          formControlName="childNameSideMargins{{ mode }}"
          [minNumber]="0"
          [maxLabelWidth]="true"
        >
          Marginesy boczne
        </app-change-number>
        <div class="colorPicker">
          Kolor czcionki
          <input
            #me
            (colorPickerChange)="
              config.controls['childPhotoNameFontColor' + mode].patchValue(
                $event
              )
            "
            [cpUseRootViewContainer]="true"
            [(colorPicker)]="config.value['childPhotoNameFontColor' + mode]"
            [style.background]="
              me.value
                ? me.value
                : config.value['childPhotoNameFontColor' + mode]
            "
          />
        </div>
        <div class="colorPicker">
          Kolor tła
          <input
            #me
            (colorPickerChange)="
              config.controls['childNameBackgroundColor' + mode].patchValue(
                $event
              )
            "
            [cpUseRootViewContainer]="true"
            [(colorPicker)]="config.value['childNameBackgroundColor' + mode]"
            [style.background]="
              me.value
                ? me.value
                : config.value['childNameBackgroundColor' + mode]
            "
          />
        </div>
        <lib-single-file-uploader
          [reverseLabel]="true"
          [context]="uploadContextForAssets"
          [contextId]="projectId"
          [maxLabelWidth]="true"
          [size]="50"
          formControlName="childNameBackgroundFile{{ mode }}"
        >
          <label>Tło dla podpisu</label>
        </lib-single-file-uploader>
      </ng-template>
      <ng-template #childConfig let-mode="mode">
        <app-change-number
          formControlName="childFrameWidth{{ mode }}"
          [minNumber]="0"
          [maxLabelWidth]="true"
          >Grubość ramki wokół osoby
        </app-change-number>
        <app-change-number
          formControlName="childRadius{{ mode }}"
          [minNumber]="0"
          [maxLabelWidth]="true"
          >Zaokrąglone rogi osoby
        </app-change-number>
        <lib-box-shadow-editor formControlName="childShadow{{ mode }}">
          Cieniowanie osoby
        </lib-box-shadow-editor>
        @if (config.value['childFrameWidth' + mode]) {
          <div class="colorPicker">
            Kolor ramki:
            <input
              #me
              (colorPickerChange)="
                config.controls['childFrameColor' + mode].patchValue($event)
              "
              [(colorPicker)]="config.value['childFrameColor' + mode]"
              [cpUseRootViewContainer]="true"
              [style.background]="
                me.value ? me.value : config.value['childFrameColor' + mode]
              "
            />
          </div>
        }
        <div class="colorPicker">
          Kolor tła dla osoby
          <input
            [cpUseRootViewContainer]="true"
            #me
            (colorPickerChange)="
              config.controls['childBackgroundColor' + mode].patchValue($event)
            "
            [(colorPicker)]="config.value['childBackgroundColor' + mode]"
            [style.background]="
              me.value ? me.value : config.value['childBackgroundColor' + mode]
            "
          />
        </div>
      </ng-template>
    </div>
  </ng-template>
  <ng-template #pickGroupSourcePhotos>
    <div class="currentGroupSourcePicker">
      <h1>Wybierz źródło zdjęć</h1>
      <mat-form-field libZalamoField>
        <mat-label>Źródło zdjęć</mat-label>
        <mat-select [formControl]="currentPhotoSourceControl" [multiple]="true">
          @for (option of sourceGroups$ | async; track option) {
            <mat-option [value]="option.photoGroupId"
              >{{ option.label | langPicker | async }} ({{ option.imagesCount }}
              zdjęć)
            </mat-option>
          }
        </mat-select>
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
      <lib-button
        (click)="
          currentPhotoSourcesPicked.next(currentPhotoSourceControl.value)
        "
        [disabled]="
          $safeNavigationMigration(currentPhotoSourceControl.value?.length) < 1
        "
        >Zapisz
      </lib-button>
    </div>
  </ng-template>
  <ng-template #layersEditor>
    <div class="mainMenu">
      <div class="groups">
        @for (group of membersMenu$ | async; track group) {
          <div class="group" (click)="addMembersGroup(group)">
            {{ group.label }}
          </div>
        }
        @if ((leadingChild$ | async)?.canAdd) {
          <div class="group" (click)="addLeadingChild()">Uczeń wiodący</div>
        }
        @if ((leadingChildPhotoOnly$ | async)?.canAdd) {
          <div class="group" (click)="addLeadingChild(false, true)">
            Uczeń wiodący - zdjęcie
          </div>
        }
        @if ((leadingChildNameOnly$ | async)?.canAdd) {
          <div class="group" (click)="addLeadingChild(true, false)">
            Uczeń wiodący - podpis
          </div>
        }
        <div class="group" (click)="addSchoolPhoto()">Zdjęcie placówki</div>
        <div class="group" (click)="addChildStaticPhoto()">Zdjęcie z sesji</div>
      </div>
      <div class="names">
        @for (name of namesMenu$ | async; track trackTextName($index, name)) {
          <div class="name" (click)="addText(name)">
            {{ name.name }}
          </div>
        }

        @if ((organizationLogo$ | async)?.canAdd) {
          <div class="name" (click)="addLogo()">Logo placówki</div>
        }
        @if ((photographerLogo$ | async)?.canAdd) {
          <div class="name" (click)="addPhotographerLogo()">Moje logo</div>
        }

        <div class="name" (click)="addStaticText()">Własny tekst</div>

        <div class="name">
          Grafika

          <input type="file" (change)="addGraphic($event)" />
        </div>
        @if (!isSinglePageTablo) {
          <div class="name" (click)="addQr()">KOD QR</div>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #errorsExplained>
    <div class="errorsContainer">
      @if ((validationStatus$ | async)?.global; as global) {
        @if (global.length > 0) {
          <section>
            <h3 class="page-header">Cały projekt</h3>
            <ul class="reason-list">
              @for (r of global; track r) {
                <li>
                  @switch (r.type) {
                    @case ('missingQR') {
                      <span>Brakuje miejsca na kod qr.</span>
                    }
                    @default {
                      <span>{{ r.reason }}</span>
                    }
                  }
                </li>
              }
            </ul>
          </section>
        }
      }
      @for (
        page of (validationStatus$ | async).pages;
        track page;
        let pageIndex = $index
      ) {
        <section>
          @if (!page.isValid) {
            @if (templateControl.value.type === 'TwoPage') {
              @if (pageIndex === 0) {
                <h3 class="page-header">Okładka</h3>
              }
              @if (pageIndex === 1) {
                <h3 class="page-header">Wnętrze</h3>
              }
            }
            <!-- Czytelna lista powodów (przetłumaczone) -->
            <ul class="reason-list">
              @for (r of page.reasons; track r) {
                <li>
                  @switch (r.type) {
                    @case ('font') {
                      <span
                        >Nie przypisano czcionki do elementu tekstowego.</span
                      >
                    }
                    @case ('statictextFont') {
                      <span
                        >Nie przypisano czcionki do elementu statycznego.</span
                      >
                    }
                    @case ('memberPhoto') {
                      <span>Nie wszystkie osoby mają przypisane zdjęcia.</span>
                    }
                    @case ('logo') {
                      <span>Brakuje pliku logo.</span>
                    }
                    @case ('groupConfig') {
                      <span
                        >Grupa ma niekompletną konfigurację (np. brak
                        czcionki).</span
                      >
                    }
                    @case ('statictextOverflow') {
                      <span>Ucięty tekst.</span>
                    }
                    @case ('missingSchoolPhoto') {
                      <span>Brakuje wybranego zdjęcia szkoły </span>
                    }
                    @case ('missingChildPhoto') {
                      <span>Brakuje wybranego zdjęcia z sesji </span>
                    }
                    @case ('backgroundDpi') {
                      <span>{{ r.reason }}</span>
                    }
                    @default {
                      <span>{{ r.reason }}</span>
                    }
                  }
                </li>
              }
            </ul>
          }
        </section>
      }
    </div>
  </ng-template>
  <ng-template #pageDump>
    <pre>{{ projectStructure$ | async | json }}</pre>
  </ng-template>
  <ng-template #singlePhotoFaceMatch>
    <div class="singleFaceMatchContainer">
      <div class="faceContainer">
        <lib-single-photo-face-match
          [contextId]="contextId"
          [imagesContext]="context"
          [memberId]="currentMemberForCrop"
          [currentFaceToMatch]="
            $safeNavigationMigration((fullProject$ | async)?.faceMatchConfig)
          "
          (faceMatchUpdated)="faceMatchUpdated($event)"
        ></lib-single-photo-face-match>
      </div>
    </div>
  </ng-template>
  <ng-template #singleChildEditForm>
    <div [formGroup]="singleChildForm" class="menu groupMenu">
      <mat-accordion>
        <!-- ──────────  GEOMETRIA / ZDJĘCIE  ────────── -->
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Zdjęcie & pozycja </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="expansionPanelContent">
            <app-change-number
              formControlName="x"
              [minNumber]="-500"
              [step]="5"
              [maxNumber]="500"
              [maxLabelWidth]="true"
              >Pozycja X
            </app-change-number>
            <app-change-number
              formControlName="y"
              [minNumber]="-500"
              [maxNumber]="500"
              [step]="5"
              [maxLabelWidth]="true"
              >Pozycja Y
            </app-change-number>
            <app-change-number
              formControlName="photoSideMargins"
              [minNumber]="0"
              [maxLabelWidth]="true"
              >Marginesy zdjęcia
            </app-change-number>
            <lib-checkbox formControlName="photoAsBackground"
              >Zdjęcie jako tło
            </lib-checkbox>
            @if (
              !singleChildForm.value.photoAsBackground &&
              !singleChildForm.value.photoAsSquare
            ) {
              <lib-checkbox formControlName="photoAsCircle"
                >Zdjęcie jako okrąg
              </lib-checkbox>
            }
            @if (
              !singleChildForm.value.photoAsBackground &&
              !singleChildForm.value.photoAsCircle
            ) {
              <lib-checkbox formControlName="photoAsSquare"
                >Zdjęcie jako kwadrat
              </lib-checkbox>
            }

            @if (!singleChildForm.value.photoAsCircle) {
              <app-change-number
                formControlName="photoRadius"
                [minNumber]="0"
                [maxLabelWidth]="true"
                >Zaokrąglenie zdjęcia
              </app-change-number>
            }

            <app-change-number
              formControlName="childPhotoFrameWidth"
              [minNumber]="0"
              [maxLabelWidth]="true"
              >Grubość ramki zdjęcia
            </app-change-number>
            @if (singleChildForm.value.childPhotoFrameWidth) {
              <div class="colorPicker">
                Kolor ramki zdjęcia:
                <input
                  #pc1
                  (colorPickerChange)="
                    singleChildForm.controls.childPhotoFrameColor.patchValue(
                      $event
                    )
                  "
                  [cpUseRootViewContainer]="true"
                  [(colorPicker)]="singleChildForm.value.childPhotoFrameColor"
                  [style.background]="
                    pc1.value || singleChildForm.value.childPhotoFrameColor
                  "
                />
              </div>
            }

            <lib-single-file-uploader
              [reverseLabel]="true"
              [context]="uploadContextForAssets"
              [contextId]="projectId"
              formControlName="childPhotoOverlayFileName"
              [size]="50"
            >
              <label>Nakładka nad zdjęciem</label>
            </lib-single-file-uploader>

            @if (singleChildForm.value.childPhotoOverlayFileName) {
              <app-change-number
                formControlName="childPhotoOverlayScale"
                [minNumber]="0"
                [maxLabelWidth]="true"
                [step]="0.01"
                >Rozmiar nakładki
              </app-change-number>
            }
            <lib-checkbox formControlName="childPhotoOverlayHasColorOverlay">
              Nakładka kolorowa
            </lib-checkbox>
            @if (singleChildForm.value.childPhotoOverlayHasColorOverlay) {
              <div class="colorPicker">
                Kolor nakładki:
                <input
                  #colorOverlayInput
                  (colorPickerChange)="
                    singleChildForm.controls.childPhotoOverlayColorOverlay.patchValue(
                      $event
                    )
                  "
                  [(colorPicker)]="
                    singleChildForm.value.childPhotoOverlayColorOverlay
                  "
                  [style.background]="
                    colorOverlayInput.value
                      ? colorOverlayInput.value
                      : singleChildForm.value.childPhotoOverlayColorOverlay
                  "
                  cpPosition="auto"
                  [cpUseRootViewContainer]="true"
                />
              </div>
            }
          </div>
        </mat-expansion-panel>

        <!-- ──────────  RAMKA / TŁO OSOBY  ────────── -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Ramka & tło osoby </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="expansionPanelContent">
            <app-change-number
              formControlName="childFrameWidth"
              [minNumber]="0"
              [maxLabelWidth]="true"
              >Grubość ramki osoby
            </app-change-number>
            @if (singleChildForm.value.childFrameWidth) {
              <div class="colorPicker">
                Kolor ramki:
                <input
                  #pc2
                  (colorPickerChange)="
                    singleChildForm.controls.childFrameColor.patchValue($event)
                  "
                  [cpUseRootViewContainer]="true"
                  [(colorPicker)]="singleChildForm.value.childFrameColor"
                  [style.background]="
                    pc2.value || singleChildForm.value.childFrameColor
                  "
                />
              </div>
            }

            <app-change-number
              formControlName="childRadius"
              [minNumber]="0"
              [maxLabelWidth]="true"
              >Zaokrąglenie osoby
            </app-change-number>
            <lib-box-shadow-editor formControlName="childShadow"
              >Cień osoby
            </lib-box-shadow-editor>

            <div class="colorPicker">
              Kolor tła dla osoby
              <input
                [cpUseRootViewContainer]="true"
                #pc3
                (colorPickerChange)="
                  singleChildForm.controls.childBackgroundColor.patchValue(
                    $event
                  )
                "
                [(colorPicker)]="singleChildForm.value.childBackgroundColor"
                [style.background]="
                  pc3.value || singleChildForm.value.childBackgroundColor
                "
              />
            </div>
          </div>
        </mat-expansion-panel>

        <!-- ──────────  PODPIS  ────────── -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Podpis</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="expansionPanelContent">
            <mat-form-field libZalamoField>
              <mat-label>Imię / nazwisko</mat-label>
              <mat-select formControlName="nameHandling">
                <mat-option value="join">Jeden wiersz</mat-option>
                <mat-option value="split">Dwa wiersze</mat-option>
              </mat-select>
              <lib-zalamo-field-decoration></lib-zalamo-field-decoration
            ></mat-form-field>

            <app-change-number
              formControlName="childFirstNameMaxFontSize"
              [maxLabelWidth]="true"
              >Max font (imie)
            </app-change-number>
            @if (singleChildForm.value.nameHandling === 'split') {
              <app-change-number
                formControlName="childLastNameMaxFontSize"
                [maxLabelWidth]="true"
                >Max font (nazwisko)
              </app-change-number>
            }
            <app-change-number
              formControlName="childFirstNameHeight"
              [maxLabelWidth]="true"
              >Wysokość pola imienia
            </app-change-number>
            @if (singleChildForm.value.nameHandling === 'split') {
              <app-change-number
                formControlName="childLastNameHeight"
                [maxLabelWidth]="true"
                >Wysokość pola nazwiska
              </app-change-number>
            }
            <app-change-number
              formControlName="childPhotoNameToPhotoGap"
              [maxLabelWidth]="true"
              [minNumber]="0"
              >Odstęp podpis–zdjęcie
            </app-change-number>

            <app-change-number
              formControlName="childNameFrameWidth"
              [maxLabelWidth]="true"
              [minNumber]="0"
              >Grubość ramki podpisu
            </app-change-number>
            @if (singleChildForm.value.childNameFrameWidth) {
              <div class="colorPicker">
                Kolor ramki podpisu
                <input
                  #pc4
                  (colorPickerChange)="
                    singleChildForm.controls.childNameNameFrameColor.patchValue(
                      $event
                    )
                  "
                  [cpUseRootViewContainer]="true"
                  [(colorPicker)]="
                    singleChildForm.value.childNameNameFrameColor
                  "
                  [style.background]="
                    pc4.value || singleChildForm.value.childNameNameFrameColor
                  "
                />
              </div>
            }
            <app-change-number
              formControlName="childNameFrameRadius"
              [minNumber]="0"
              [maxLabelWidth]="true"
              >Zaokrąglenie ramki podpisu
            </app-change-number>

            <lib-single-file-uploader
              [reverseLabel]="true"
              [context]="uploadContextForAssets"
              [contextId]="projectId"
              formControlName="childNameBackgroundFile"
              [size]="50"
            >
              <label>Tło podpisu (grafika)</label>
            </lib-single-file-uploader>

            <div class="colorPicker">
              Kolor tła podpisu
              <input
                #pc5
                (colorPickerChange)="
                  singleChildForm.controls.childNameBackgroundColor.patchValue(
                    $event
                  )
                "
                [cpUseRootViewContainer]="true"
                [(colorPicker)]="singleChildForm.value.childNameBackgroundColor"
                [style.background]="
                  pc5.value || singleChildForm.value.childNameBackgroundColor
                "
              />
            </div>

            <div class="colorPicker">
              Kolor czcionki podpisu
              <input
                #pc6
                (colorPickerChange)="
                  singleChildForm.controls.childPhotoNameFontColor.patchValue(
                    $event
                  )
                "
                [cpUseRootViewContainer]="true"
                [(colorPicker)]="singleChildForm.value.childPhotoNameFontColor"
                [style.background]="
                  pc6.value || singleChildForm.value.childPhotoNameFontColor
                "
              />
            </div>

            <app-change-number
              formControlName="childNameSideMargins"
              [maxLabelWidth]="true"
              [minNumber]="0"
              >Boczne marginesy podpisu
            </app-change-number>
            <app-change-number formControlName="childNameTilt" [minNumber]="0"
              >Losowy obrót podpisu
            </app-change-number>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-template>
</mat-drawer-container>
<div
  class="menu-anchor"
  [style.left.px]="menuPosition.x"
  [style.top.px]="menuPosition.y"
  [matMenuTriggerFor]="menu"
  [matMenuTriggerRestoreFocus]="false"
  #menuTrigger="matMenuTrigger"
></div>
<mat-menu #menu="matMenu">
  @for (action of currentRightMenuOptions$ | async; track action) {
    <button mat-menu-item (click)="action.action()">
      {{ action.label }}
    </button>
  }
</mat-menu>
